interface EnvConfig {
  VITE_MSAL_CLIENTID: string;
  VITE_MSAL_AUTHORITY: string;
  VITE_MSAL_API_ADDRESS: string;
  VITE_API_ENDPOINT: string;
  VITE_CLARITY_PROJECT_ID: string;
  VITE_APPLICATIONINSIGHTS_CONNECTION_STRING: string;
}

export function getEnvironmentVariable(key: keyof EnvConfig): string {
  // During development, use Vite's import.meta.env
  if (import.meta.env.DEV) {
    return import.meta.env[key] as string;
  }

  // In production, use the runtime config
  const runtimeConfig = (window as any).ENV_CONFIG;
  if (!runtimeConfig || !runtimeConfig[key]) {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return runtimeConfig[key];
}

export function getEnvConfig(): EnvConfig {
  if (import.meta.env.DEV) {
    return {
      VITE_MSAL_CLIENTID: import.meta.env.VITE_MSAL_CLIENTID,
      VITE_MSAL_AUTHORITY: import.meta.env.VITE_MSAL_AUTHORITY,
      VITE_MSAL_API_ADDRESS: import.meta.env.VITE_MSAL_API_ADDRESS,
      VITE_API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
      VITE_CLARITY_PROJECT_ID: import.meta.env.VITE_CLARITY_PROJECT_ID,
      VITE_APPLICATIONINSIGHTS_CONNECTION_STRING: import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING,
    };
  }

  return (window as any).ENV_CONFIG;
}